declare namespace $ {

	type $mol_view__sub_bog_smalljs_structure_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_structure_step__number_bog_smalljs_structure_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_structure_step['number'] >
	>
	type $bog_smalljs_structure_step__text_bog_smalljs_structure_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step1_text'] >
		,
		ReturnType< $bog_smalljs_structure_step['text'] >
	>
	type $bog_smalljs_structure_step__code_bog_smalljs_structure_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step1_code'] >
		,
		ReturnType< $bog_smalljs_structure_step['code'] >
	>
	type $bog_smalljs_structure_step__number_bog_smalljs_structure_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_structure_step['number'] >
	>
	type $bog_smalljs_structure_step__text_bog_smalljs_structure_7 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step2_text'] >
		,
		ReturnType< $bog_smalljs_structure_step['text'] >
	>
	type $bog_smalljs_structure_step__code_bog_smalljs_structure_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step2_code'] >
		,
		ReturnType< $bog_smalljs_structure_step['code'] >
	>
	type $bog_smalljs_structure_step__number_bog_smalljs_structure_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_structure_step['number'] >
	>
	type $bog_smalljs_structure_step__text_bog_smalljs_structure_10 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step3_text'] >
		,
		ReturnType< $bog_smalljs_structure_step['text'] >
	>
	type $bog_smalljs_structure_step__code_bog_smalljs_structure_11 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step3_code'] >
		,
		ReturnType< $bog_smalljs_structure_step['code'] >
	>
	type $bog_smalljs_structure_step__number_bog_smalljs_structure_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_structure_step['number'] >
	>
	type $bog_smalljs_structure_step__text_bog_smalljs_structure_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step4_text'] >
		,
		ReturnType< $bog_smalljs_structure_step['text'] >
	>
	type $bog_smalljs_structure_step__code_bog_smalljs_structure_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step4_code'] >
		,
		ReturnType< $bog_smalljs_structure_step['code'] >
	>
	type $bog_smalljs_structure_step__number_bog_smalljs_structure_15 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_structure_step['number'] >
	>
	type $bog_smalljs_structure_step__text_bog_smalljs_structure_16 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step5_text'] >
		,
		ReturnType< $bog_smalljs_structure_step['text'] >
	>
	type $bog_smalljs_structure_step__code_bog_smalljs_structure_17 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['step5_code'] >
		,
		ReturnType< $bog_smalljs_structure_step['code'] >
	>
	type $mol_text__text_bog_smalljs_structure_18 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['why_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_smalljs_structure_19 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['why_title'] >
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_smalljs_structure_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_view__sub_bog_smalljs_structure_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_structure_row__prefix_bog_smalljs_structure_22 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_prefix'] >
		,
		ReturnType< $bog_smalljs_structure_row['prefix'] >
	>
	type $bog_smalljs_structure_row__name_bog_smalljs_structure_23 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_name'] >
		,
		ReturnType< $bog_smalljs_structure_row['name'] >
	>
	type $bog_smalljs_structure_row__pad_bog_smalljs_structure_24 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_pad'] >
		,
		ReturnType< $bog_smalljs_structure_row['pad'] >
	>
	type $bog_smalljs_structure_row__comment_bog_smalljs_structure_25 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_comment'] >
		,
		ReturnType< $bog_smalljs_structure_row['comment'] >
	>
	type $bog_smalljs_structure_row__note_bog_smalljs_structure_26 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_note'] >
		,
		ReturnType< $bog_smalljs_structure_row['note'] >
	>
	type $bog_smalljs_structure_row__kind_bog_smalljs_structure_27 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_kind'] >
		,
		ReturnType< $bog_smalljs_structure_row['kind'] >
	>
	type $bog_smalljs_structure_row__active_bog_smalljs_structure_28 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_active'] >
		,
		ReturnType< $bog_smalljs_structure_row['active'] >
	>
	type $bog_smalljs_structure_row__pickable_bog_smalljs_structure_29 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['row_pickable'] >
		,
		ReturnType< $bog_smalljs_structure_row['pickable'] >
	>
	type $bog_smalljs_structure_row__pick_bog_smalljs_structure_30 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure['pick'] >
		,
		ReturnType< $bog_smalljs_structure_row['pick'] >
	>
	export class $bog_smalljs_structure extends $mol_view {
		rows( ): readonly(any)[]
		Tree( ): $mol_view
		Steps_title( ): $mol_view
		Step1( ): $bog_smalljs_structure_step
		Step2( ): $bog_smalljs_structure_step
		Step3( ): $bog_smalljs_structure_step
		Step4( ): $bog_smalljs_structure_step
		Step5( ): $bog_smalljs_structure_step
		Why_text( ): $mol_text
		Why( ): $mol_expander
		Steps( ): $mol_view
		tree( ): string
		active( ): string
		pickable( ): boolean
		plain( ): boolean
		steps_showed( ): boolean
		pick( id: any, next?: any ): any
		file( next?: any ): any
		row_prefix( id: any): string
		row_name( id: any): string
		row_pad( id: any): string
		row_comment( id: any): string
		row_note( id: any): string
		row_kind( id: any): string
		row_active( id: any): boolean
		row_pickable( id: any): boolean
		hint_workspace( ): string
		hint_registry( ): string
		hint_framework( ): string
		hint_package( ): string
		hint_gitattributes( ): string
		hint_registry_own( ): string
		hint_project( ): string
		hint_entry( ): string
		hint_tree( ): string
		hint_ts( ): string
		hint_css( ): string
		hint_submodule( ): string
		steps_title( ): string
		step1_text( ): string
		step1_code( ): string
		step2_text( ): string
		step2_code( ): string
		step3_text( ): string
		step3_code( ): string
		step4_text( ): string
		step4_code( ): string
		step5_text( ): string
		step5_code( ): string
		why_title( ): string
		why_text( ): string
		attr( ): ({ 
			'bog_smalljs_structure_steps': ReturnType< $bog_smalljs_structure['steps_showed'] >,
			'bog_smalljs_structure_plain': ReturnType< $bog_smalljs_structure['plain'] >,
		}) 
		sub( ): readonly(any)[]
		Row( id: any): $bog_smalljs_structure_row
	}
	
}

//# sourceMappingURL=structure.view.tree.d.ts.map